export type Purchase = {
  name: string
  city: string
  product: string
  time: string
}

export const purchases: Purchase[] = [
  { name: 'María G.', city: 'Santiago', product: 'el pack completo', time: 'hace 2 minutos' },
  { name: 'Lucía F.', city: 'Buenos Aires', product: 'el pack completo', time: 'hace 4 minutos' },
  { name: 'Carmen R.', city: 'Madrid', product: 'el pack completo', time: 'hace 6 minutos' },
  { name: 'Valeria M.', city: 'Ciudad de México', product: 'el pack completo', time: 'hace 8 minutos' },
  { name: 'Andrés P.', city: 'Bogotá', product: 'el pack completo', time: 'hace 11 minutos' },
  { name: 'Sofía T.', city: 'Lima', product: 'el pack completo', time: 'hace 13 minutos' },
  { name: 'Paula C.', city: 'Montevideo', product: 'el pack completo', time: 'hace 15 minutos' },
  { name: 'Rosa H.', city: 'Ciudad de Guatemala', product: 'el pack completo', time: 'hace 17 minutos' },
  { name: 'Daniela S.', city: 'Quito', product: 'el pack completo', time: 'hace 19 minutos' },
  { name: 'Javier A.', city: 'Barcelona', product: 'el pack completo', time: 'hace 21 minutos' },
  { name: 'Natalia B.', city: 'Córdoba', product: 'el pack completo', time: 'hace 24 minutos' },
  { name: 'Gabriela V.', city: 'San José', product: 'el pack completo', time: 'hace 27 minutos' },
]
